import { HttpInterceptorFn } from '@angular/common/http';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const authToken = `Bearer ${localStorage.getItem('access_token')}`;
  const authReq = req.clone({
    setHeaders: {
      Authorization: authToken
    }
  });
  return next(authReq);
};
